module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_f_piebald.2e7d5fff.png";